<div class="main">
    <div class="dashboard-header">
        <img src="../../assets/1.svg" alt="Logo" id="logo">
    </div>
    <div class="navbar">
        <span class="nav-item">
            <a class="dropdown-content"> Content Programming <span>▼</span></a>
            <div class="dropdown">
                <a (click)="this.filteredText = '' ;searchTerm = ''; this.openConetnt  = true; assignSongsToParticularObj = null; 
                             filteredMusicArray = []; musicArray = []; musicListedArray = []; 
                             tabMusicArray = []; selectAll = false; muiscId  = null; 
                             viewContent = true;this.pageSize = 10;this.showFilteredOptions = false; containersNmae  = null; openViewContent()">
                    View Content
                </a>
                <a (click)="opeTags(); selectAll = false; searchTerm = '';"> Manage Layout</a>
                <a (click)="openManageNotification()" > Manage Notifications</a>
            </div>
        </span>
        <span class="welcome-note">Welcome : </span>
        <span class="nav-item">
            <span class="user-data" >{{userName ? userName : 'User'}}</span><a><i
                    class="fas fa-user"></i></a>
            <div class="dropdown">
                <a
                    (click)="openAddForm(addChangePasswordModal); this.passwordForm.reset();this.showCurrentPassword = false; this.showNewPassword = false; this.showConfirmPassword = false; ">
                    Change Password</a>
                <a (click)="openAddForm(openLogOutModel)"> Logout</a>
            </div>
        </span>
    </div>

    <ng-container *ngIf="Artist">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{'/'}} Content Programming {{'/'}}
            <a href="javascript:void(0);"
                style="color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1)); text-decoration: none;"
                (click)="opeTags();this.searchTerm = '';">App Section</a>
            {{'/'}} Containers
        </span>
        <div class="table-container">
            <div class="table-header"></div>
            <div class="table-controls">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Artist')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Artist')"
                            (keypress)="preventSpace($event)" placeholder="Search for container..."
                            class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'id'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;" (click)="sortData('name', 'Artists')">Name
                            <span style="float: right;" *ngIf="sortColumn === 'name'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('title', 'Artists')">Description
                            <span style="float: right;" *ngIf="sortColumn === 'title'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">
                            Total Capacity
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'username'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;">Consumed
                            Capacity
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'username'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;">Options</th>
                        <th style="text-align: center;">Content</th>
                    </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="onDropContainer($event)">
                    <tr *ngIf="artistArray?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of artistArray; let i = index" cdkDrag>
                        <td cdkDragHandle
                            style="font-size: 15px !important;; text-align: center; cursor:grab !important">{{
                            (currentPage - 1) * pageSize + i + 1 }}</td>
                        <td cdkDragHandle
                            style="font-size: 15px !important;; text-align: center; cursor:grab !important">{{
                            publisher.name }}</td>
                        <td cdkDragHandle
                            style="font-size: 15px !important;; text-align: center; cursor:grab !important">{{
                            publisher.title }}</td>
                        <td cdkDragHandle
                            style="font-size: 15px !important;; text-align: center; cursor:grab !important">{{
                            publisher.totalCapacity }}</td>
                        <td cdkDragHandle
                            style="font-size: 15px !important;; text-align: center; cursor:grab !important">{{
                            publisher.consumedCapacity }}</td>
                        <td style="font-size: 15px !important;; text-align: center; cursor:grab !important">
                            <div style="display: flex; justify-content: space-around;">
                                <span (click)="openAddForm(addlayoutModal); EditTag(publisher, 'Layout')"
                                    style="color: cornflowerblue; cursor:pointer;">Edit</span>
                                <span>
                                    <label class="switch">
                                        <input type="checkbox" [checked]="publisher.isEnabled === true"
                                            (change)="onStatusChange($event, publisher)">
                                        <span class="slider"></span>
                                    </label>
                                </span>
                            </div>
                        </td>
                        <td cdkDragHandle
                            style="font-size: 15px !important;; text-align: center; cursor:grab !important;">
                            <div style="display: flex; justify-content: space-around; align-items: center;gap: 2.7rem;">
                                <span [ngStyle]="{
                                    color: isGray(publisher.name) ? 'lightgray' : 'cornflowerblue',
                                    'margin-left': (isGray(publisher.name) && funcsName(publisher) == 'Callertune') ? '-5px' : '0px',
                                    cursor: isGray(publisher.name) ? 'not-allowed' : 'pointer'
                                  }"
                                    (click)="moveToCarasoluesContent(publisher);this.pageSize = 10;this.searchTerm = ''; this.selectAll = false;this.songDetailsArray = [];this.callertuneDetails = [];this.genres = [];this.artistDetails = []; this.musicArray = [];this.roleArray = [];">
                                    Assign Carousel Content
                                </span>
                                <span
                                    (click)="moveToAssignSongs(publisher, '');this.manageContent = publisher;this.showFilteredOptions = false;this.pageSize = 10; this.selectAll = false; this.viewContent = false;this.searchTerm = '';this.filteredMusicArray=[];this.musicArray = []; this.musicListedArray = [];this.tabMusicArray = [];"
                                    [ngStyle]="{ color: isGray(publisher.name) ? 'lightgray' : 'cornflowerblue', cursor: isGray(publisher.name) ? 'not-allowed' : 'pointer' }">
                                    {{(publisher.name == 'GLOBAL_MIX') ? 'Manage Content' :  ('Assign' + ' ' + funcName(publisher))}}
                                </span>
                                <ng-container *ngIf="!isGray(publisher.name); else placeholder">
                                    <span (click)="moveToViewALLContent(publisher);this.addGloboloContent='';this.pageSize = 10;this.searchTerm = '';this.deployments = false;"
                                        [ngStyle]="{ color: 'cornflowerblue', cursor: 'pointer' }">
                                        View All
                                    </span>
                                </ng-container>
                                <ng-template #placeholder>
                                    <span style="visibility: hidden;">View All</span>
                                </ng-template>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(artistArray, 'Artist')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page, artistArray, 'Artist')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(artistArray, 'Artist')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>
        </div>

        <ng-template #addlayoutModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}}</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form -->
                <form [formGroup]="laoutForm" (ngSubmit)="onAddArtist()" style="padding: 20px;">
                    <!-- Name Field -->
                    <div class="mb-3">
                        <label for="name" class="form-label" style="margin-bottom: 7px;">Description
                            <span>
                                <strong style="color: red;">*</strong>
                            </span>
                        </label>
                        <input type="text" class="form-control" (keypress)="preventSpace($event)" id="name"
                            placeholder="Enter Description" formControlName="name" />
                        <!-- Validation Error Message -->
                        <div *ngIf="laoutForm.get('name')?.touched && laoutForm.get('name')?.invalid">
                            <small class="text-danger" *ngIf="laoutForm.get('name')?.hasError('required')">
                                Description is required.
                            </small>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary custom-btn-add"
                    style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddArtist()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary custom-btn-cancel"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>
    </ng-container>


    <ng-container *ngIf="user">
        <span style="position: relative; bottom: -7em;left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a> {{'/'}} User Management {{'/'}} User {{'/'}}
            View
        </span>

        <div class="table-container">
            <div class="table-header">
                <button (click)="openAddForm(addUserModal); this.userForm.reset();" class="btn-create"
                    style="font-size: 15px !important;;font-weight: 600;">
                    <i class="fas fa-plus"></i> Create User
                </button>
            </div>

            <div class="table-controls">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'User')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>

                <div class="search_table" style="margin-top: -5px; margin-bottom: 5px;">
                    <label for="search" style="font-size: 15px !important;;">Search:</label>
                    <input type="text" [(ngModel)]="searchTerm" (input)="applySearch('User')"
                        placeholder="Search for user..." />
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'id'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;" (click)="sortData('username', 'User')">Name
                            <span style="float: right;" *ngIf="sortColumn === 'username'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('email', 'User')">Email Id
                            <span style="float: right;" *ngIf="sortColumn === 'email'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('contact', 'User')">Contact Number
                            <span style="float: right;" *ngIf="sortColumn === 'contact'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('roles', 'User')">Role
                            <span style="float: right;" *ngIf="sortColumn === 'roles'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <!-- <th style="text-align: center;">Email</th> -->
                        <th style="text-align: center;">Options</th>
                        <!-- <th style="text-align: center;">Publisher-Publishers</th> -->
                    </tr>
                </thead>
                <tbody>
                    <!-- Check if the filtered tags list is empty -->
                    <tr *ngIf="userArray?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of userArray; let i = index">
                        <td style="font-size: 15px !important;; text-align: center;">{{ (currentPage - 1) * pageSize + i
                            + 1 }}</td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.username }}</td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.email }}</td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.contact }}</td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.roles.join(', ') }}</td>
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ publisher.email }}</td> -->
                        <td style="font-size: 15px !important;;text-align: center;">
                            <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'User','')" style="margin-right: 8px;
                        padding: 5px;
                        border: none;
                        background: none;
                        margin-left: 5px;text-align: center;"><i class="fa fa-close"></i> Delete</button>
                            <button (click)="openAddForm(addUserModal); EditTag(publisher, 'User')" style="margin-right: 8px;
                        padding: 5px;
                        border: none;
                        background: none;
                        margin-left: 5px;text-align: center;"><i class="fas fa-pen"></i> Edit</button>
                        </td>
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ 'View' }} <i class="fas fa-share"></i></td> -->
                    </tr>
                </tbody>
            </table>
            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(userArray, 'User')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,userArray, 'User')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(userArray,'User')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>
        </div>
        <ng-template #addUserModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} User</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="userForm" (ngSubmit)="onAddUser()" style="padding: 20px;">
                    <!-- Username Field -->
                    <div class="mb-3">
                        <label for="username" class="form-label" style="margin-bottom: 7px;">User Name <span
                                style="color: red;">*</span></label>
                        <input style="width: 460px;" autocomplete="off" type="text" class="form-control" id="username"
                            formControlName="username" placeholder="Enter Username" />
                        <div *ngIf="userForm.get('username')?.touched && userForm.get('username')?.invalid"
                            class="text-danger">
                            Username is required.
                        </div>
                    </div>

                    <!-- Email Field -->
                    <div class="mb-3">
                        <label for="email" class="form-label" style="margin-bottom: 7px;">Email <span
                                style="color: red;">*</span></label>
                        <input style="width: 460px;" type="email" class="form-control" id="email"
                            formControlName="email" placeholder="Enter Email" />
                        <div *ngIf="userForm.get('email')?.touched && userForm.get('email')?.invalid"
                            class="text-danger">
                            <span *ngIf="userForm.get('email')?.hasError('required')">Email is required.</span>
                            <span *ngIf="userForm.get('email')?.hasError('email')">Enter a valid email.</span>
                        </div>
                    </div>

                    <!-- Contact Number Field -->
                    <div class="mb-3">
                        <label for="contactNumber" style="margin-bottom: 7px;" class="form-label">Contact Number <span
                                style="color: red;">*</span></label>
                        <input style="width: 460px;" type="text" class="form-control" id="contactNumber"
                            formControlName="contactNumber" placeholder="Enter Contact Number" />
                        <div *ngIf="userForm.get('contactNumber')?.touched && userForm.get('contactNumber')?.invalid"
                            class="text-danger">
                            <span *ngIf="userForm.get('contactNumber')?.hasError('required')">Contact number is
                                required.</span>
                            <span *ngIf="userForm.get('contactNumber')?.hasError('pattern')">Enter a valid 10-digit
                                number.</span>
                        </div>
                    </div>

                    <!-- Password Field -->
                    <div class="mb-3">
                        <label for="password" style="margin-bottom: 7px;" class="form-label">Password <span
                                style="color: red;">*</span></label>
                        <input style="width: 460px;" [type]="isPasswordVisible ? 'text' : 'password'"
                            class="form-control" id="password" formControlName="password" placeholder="Enter Password"
                            autocomplete="new-password" />
                        <button style="float: right; margin-top: -45px;" type="button"
                            class="btn btn-outline-secondary eye" (click)="togglePasswordVisibility()" tabindex="-1">
                            <i [class]="isPasswordVisible ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                        </button>
                        <div *ngIf="userForm.get('password')?.touched && userForm.get('password')?.invalid"
                            class="text-danger">
                            <span *ngIf="userForm.get('password')?.hasError('required')">Password is required.</span>
                            <span *ngIf="userForm.get('password')?.hasError('minlength')">Password must be at least 6
                                characters long.</span>
                        </div>
                    </div>


                    <!-- Role Dropdown -->
                    <div class="mb-3">
                        <label for="role" style="margin-bottom: 7px;" class="form-label">Role <span
                                style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown style="width: 460px;" class="form-select" [placeholder]="'Select Role'"
                            [settings]="dropdownSettings" [data]="roleArray" formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid" class="text-danger">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"
                    style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddUser()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>


    </ng-container>

    <ng-container *ngIf="Generes">
        <span style="position: relative; bottom: -7em;left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a> {{'/'}} Content Configuration {{'/'}}
            Generes {{'/'}} View
        </span>

        <div class="table-container">
            <div class="table-header">
                <button (click)="openAddForm(addGenreModal);this.genreForm.reset();" class="btn-create"
                    style="font-size: 15px !important;;font-weight: 600;">
                    <i class="fas fa-plus"></i> Create Genre
                </button>
            </div>

            <div class="table-controls">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Genre')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Genre')"
                            (keypress)="preventSpace($event)" placeholder="Search for genre..." class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'id'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;">Image
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'categoryImageUrl'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;" (click)="sortData('categoryName', 'Genres')">Genre Name
                            <span style="float: right;" *ngIf="sortColumn === 'categoryName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <!-- <th style="text-align: center;">Content Type</th> -->
                        <th style="text-align: center;">Options</th>
                        <!-- <th style="text-align: center;">Publisher-Publishers</th> -->
                    </tr>
                </thead>
                <tbody>
                    <!-- Check if the filtered tags list is empty -->
                    <tr *ngIf="genreArray?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of genreArray ; let i = index">
                        <td style="font-size: 15px !important;; text-align: center;">{{ (currentPage - 1) * pageSize + i
                            + 1 }}</td>
                        <td style="font-size: 15px !important;;text-align: center;"><img
                                style="height: 40px;width: 40px;border-radius: 50%;"
                                [src]="'https://' + publisher.categoryImageUrl" alt=""></td>
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ publisher.categoryImageUrl }}</td> -->
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.categoryName }}</td>
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ publisher.email }}</td> -->
                        <td style="font-size: 15px !important;;text-align: center;">
                            <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Genres','')" style="margin-right: 8px;
                            padding: 5px;
                            border: none;
                            background: none;
                            margin-left: 5px;text-align: center;"><i class="fa fa-close"></i> Delete</button>
                            <button (click)="openAddForm(addGenreModal); EditTag(publisher, 'Genres')" style="margin-right: 8px;
                            padding: 5px;
                            border: none;
                            background: none;
                            margin-left: 5px;text-align: center;"><i class="fas fa-pen"></i> Edit</button>
                        </td>
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ 'View' }} <i class="fas fa-share"></i></td> -->
                    </tr>
                </tbody>
            </table>
            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(genreArray, 'Genre')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,genreArray, 'Genre')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(genreArray, 'Genre')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>
        </div>
        <ng-template #addGenreModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Genres</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form for Genres -->
                <form [formGroup]="genreForm" (ngSubmit)="onAddGenre()" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="genreName" class="form-label" style="margin-bottom: 7px;">Genres Name
                            <span *ngIf="genreForm.get('genreName')?.hasError('required')">
                                <strong style="color: red;">*</strong>
                            </span>
                        </label>
                        <input type="text" class="form-control" id="genreName" placeholder="Enter Valid Name"
                            formControlName="genreName" />
                        <!-- Validation Error Message -->
                        <div *ngIf="genreForm.get('genreName')?.touched && genreForm.get('genreName')?.invalid">
                            <small class="text-danger" *ngIf="genreForm.get('genreName')?.hasError('required')">
                                Genre Name is required.
                            </small>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="genreImage" class="form-label" style="margin-bottom: 7px;">Genre Image</label>
                        <input style="margin-left: 0px !important;" type="file" class="form-control" id="genreImage"
                            (change)="onGenreFileSelected($event)" />
                        <!-- Preview -->
                        <div *ngIf="selectedenereImage" style="margin-top: 10px;">
                            <!-- <p>Selected Image:</p> -->
                            <img [src]="selectedenereImage" alt="Selected Artist"
                                style="max-width: 100px; max-height: 100px; border: 1px solid #ccc;" />
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"
                    style="margin-right: 10px;background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddGenre()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

    <ng-container *ngIf="tags">
        <span style="position: relative; bottom: -7em;left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a> {{'/'}} Content Programming {{'/'}} App
            Section
        </span>

        <div class="table-container">
            <div class="table-header app_section">
                {{'App Section'}}
            </div>

            <div class="table-controls">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Tag')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Tag')"
                            (keypress)="preventSpace($event)" placeholder="Search for app section..."
                            class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                        </th>
                        <th style="text-align: center;" (click)="sortData('name', 'Tags')">Name
                            <span style="float: right;" *ngIf="sortColumn === 'name'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('description', 'Tags')">Description
                            <span style="float: right;" *ngIf="sortColumn === 'description'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Page Layout</th>
                        <!-- <th style="text-align: center;">Publisher-Publishers</th> -->
                    </tr>
                </thead>
                <tbody>
                    <!-- Check if the filtered tags list is empty -->
                    <tr *ngIf="tagsArray?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <!-- Display the actual tags -->
                    <tr *ngFor="let publisher of tagsArray ; let i = index">
                        <td style="font-size: 15px !important;; text-align: center;">
                            {{ (currentPage - 1) * pageSize + i + 1 }}
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;">
                            {{ publisher.name }}
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;">
                            {{ publisher.description }}
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;">
                            <button style="border: 1px solid gray;"
                                (click)="moveToContainers(publisher.name);this.searchTerm = '';"
                                [disabled]="publisher.name === 'Search tab'" [ngStyle]="{
                                cursor: publisher.name === 'Search tab' ? 'not-allowed' : 'pointer',
                                color: publisher.name === 'Search tab' ? '#a9a9a9' : 'black'
                              }" class="layout_btn">
                                {{ 'Manage Layout' }}
                            </button>
                        </td>

                        <!-- <td style="font-size: 15px !important;; text-align: center;">
                            <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Tags')"
                                style="margin-right: 8px; padding: 5px; border: none; background: none; margin-left: 5px; text-align: center;">
                                <i class="fa fa-close"></i> Delete
                            </button>
                            <button (click)="openAddForm(addTagModal); EditTag(publisher, 'Tags')"
                                style="margin-right: 8px; padding: 5px; border: none; background: none; margin-left: 5px; text-align: center;">
                                <i class="fas fa-pen"></i> Edit
                            </button>
                        </td> -->
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(tagsArray, 'Tag')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,tagsArray, 'Tag')"
                            [disabled]="page === currentPage" [ngStyle]="{
                              'font-size': '15px',
                             'margin': '0 5px',
                             'background-color': currentPage === page ? '#007bff' : '',
                             'color': currentPage === page ? '#fff' : ''
                           }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(tagsArray, 'Tag')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>
        </div>
        <ng-template #addTagModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Tag</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="tagForm" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="tagName" class="form-label" style="margin-bottom: 7px;">Tag Name<span
                                style="color: red;"> *</span></label>
                        <input type="text" class="form-control" id="tagName" placeholder="Enter Valid Name"
                            formControlName="tagName">
                        <div *ngIf="tagForm.get('tagName')?.invalid && tagForm.get('tagName')?.touched"
                            class="text-danger">
                            Tag Name is required
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="contentType" class="form-label" style="margin-bottom: 7px;">Content Type<span
                                style="color: red;"> *</span></label>
                        <select class="form-control" id="contentType" formControlName="contentType">
                            <option value="" disabled selected>Select Content Type</option>
                            <option value="Music">Music</option>
                        </select>
                        <div *ngIf="tagForm.get('contentType')?.invalid && tagForm.get('contentType')?.touched"
                            class="text-danger">
                            Content Type is required
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="onAddTags()"
                    style="margin-right: 10px;background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;">{{toBeEditedTagId
                    ? 'Edit' : 'Add'}}</button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="onCancel()">Cancel</button>
            </div>
        </ng-template>

    </ng-container>

    <ng-template #addChangePasswordModal let-modal>
        <div class="modal-dialog">
            <div class="modal-content change-password-container">
                <div class="modal-header">
                    <h5 class="modal-title">Change Password</h5>
                    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body" style="padding: 20px;">
                    <form [formGroup]="passwordForm" (ngSubmit)="chnagePaasword()" style="margin-top: -25px;">
                        <!-- Email Field -->
                        <!-- <div class="form-group">
                            <label for="email">Email<span style="color: red;margin-left: 5px;">*</span></label>
                            <input (keypress)="preventSpace($event)" style="width: 459px;" type="email" id="email"
                                autocomplete="off" class="form-control" formControlName="email"
                                placeholder="Enter Email" />
                            <div *ngIf="passwordForm.get('email')?.touched && passwordForm.get('email')?.invalid"
                                style="color: red;margin-left:5px;">
                                <span *ngIf="passwordForm.get('email')?.hasError('required')">Email is required.</span>
                                <span *ngIf="passwordForm.get('email')?.hasError('pattern')">Enter a valid email.</span>
                            </div>
                        </div> -->

                        <!-- Current Password Field -->
                        <div class="form-group">
                            <label for="currentPassword">Current Password<span
                                    style="color: red;margin-left: 5px;">*</span></label>
                            <div class="input-group">
                                <input (keypress)="preventSpace($event)" maxlength="20"
                                    [type]="showCurrentPassword ? 'text' : 'password'" id="currentPassword"
                                    autocomplete="new-password" class="form-control" formControlName="currentPassword"
                                    placeholder="Enter Current Password" />
                                <i class="fa" [ngClass]="showCurrentPassword ? 'fa-eye-slash' : 'fa-eye'"
                                    (click)="togglePasswordVisibilitys('current')"
                                    style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                                </i>
                            </div>
                            <div *ngIf="passwordForm.get('currentPassword')?.touched && passwordForm.get('currentPassword')?.invalid"
                                style="color: red;margin-left:5px;">
                                Current password is required.
                            </div>
                        </div>

                        <!-- New Password Field -->
                        <div class="form-group">
                            <label for="newPassword">New Password<span
                                    style="color: red;margin-left: 5px;">*</span></label>
                            <div class="input-group">
                                <input (keypress)="preventSpace($event)" maxlength="20"
                                    [type]="showNewPassword ? 'text' : 'password'" autocomplete="new-password"
                                    id="newPassword" class="form-control" formControlName="newPassword"
                                    placeholder="Enter New Password" />
                                <i class="fa" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"
                                    (click)="togglePasswordVisibilitys('new')"
                                    style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                                </i>
                            </div>
                            <div *ngIf="passwordForm.get('newPassword')?.touched && passwordForm.get('newPassword')?.invalid"
                                style="color: red;margin-left:5px;">
                                <span *ngIf="passwordForm.get('newPassword')?.hasError('required')">
                                    New password is required.
                                </span>
                                <span *ngIf="!passwordForm.get('newPassword')?.hasError('required') && 
                                              passwordForm.get('newPassword')?.hasError('minlength')">
                                    Password must be at least 6 characters long.
                                </span>
                                <span *ngIf="!passwordForm.get('newPassword')?.hasError('required') && 
                                              !passwordForm.get('newPassword')?.hasError('minlength') && 
                                              passwordForm.get('newPassword')?.hasError('maxlength')">
                                    Password must be no more than 20 characters long.
                                </span>
                                <span *ngIf="!passwordForm.get('newPassword')?.hasError('required') && 
                                              !passwordForm.get('newPassword')?.hasError('minlength') && 
                                              !passwordForm.get('newPassword')?.hasError('maxlength') && 
                                              passwordForm.get('newPassword')?.hasError('passwordStrength')">
                                    Password must contain at least one special character, one digit, and one uppercase
                                    letter.
                                </span>
                            </div>
                        </div>

                        <!-- Confirm Password Field -->
                        <div class="form-group">
                            <label for="confirmPassword">Confirm Password<span
                                    style="color: red;margin-left: 5px;">*</span></label>
                            <div class="input-group" style="position: relative;">
                                <input (keypress)="preventSpace($event)" maxlength="20" autocomplete="new-password"
                                    [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword"
                                    class="form-control" formControlName="confirmPassword"
                                    placeholder="Confirm New Password" />
                                <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"
                                    (click)="togglePasswordVisibilitys('confirm')"
                                    style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                                </i>
                            </div>
                            <div *ngIf="passwordForm.get('confirmPassword')?.touched && passwordForm.get('confirmPassword')?.invalid"
                                style="color: red;margin-left:5px;">
                                Confirm password is required.
                            </div>
                            <div *ngIf="passwordMismatch" style="color: red;margin-left:5px;">
                                Passwords do not match.
                            </div>
                        </div>

                        <!-- Buttons -->
                        <div class="modal-footer" style="margin-top: 20px;padding: 0 !important;">
                            <button type="button" class="btn custom-btn-change-password" style="margin-right:10px"
                                (click)="chnagePaasword()">
                                Change Password
                            </button>
                            <button type="button" class="btn btn-secondary custom-btn-cancel"
                                (click)="modal.dismiss('Cancel click')">
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-container *ngIf="openMusicAddForm">
        <div class="music-add-container" style="margin-top: 100px;">
            <h2 style="font-size: 15px !important;;font-weight: 400;"> {{toBeEditedTagId ? 'Edit' : 'Add'}} Music</h2>
            <hr class="section-dividers">
            <form [formGroup]="musicForm" (ngSubmit)="onAddMusic()">

                <!-- Basic Details Section -->
                <div class="section-header">Basic Details</div>
                <hr class="section-divider">
                <div style="display: flex;width: 59%;justify-content: space-between;">
                    <div class="form-group">
                        <label for="publisher">Publisher</label>
                        <select id="publisher" formControlName="publisher" class="form-control"
                            style="margin-right: 20px;height: 40px;">
                            <option value="" disabled selected>Select Publisher</option>
                            <ng-container *ngFor="let item of publisherArray">
                                <option [value]=item.publisherName>{{item.publisherName}}</option>
                            </ng-container>
                        </select>
                        <div
                            *ngIf="musicForm.get('publisher').hasError('required') && musicForm.get('publisher').touched">
                            <small class="text-danger">Publisher is required.</small>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="tags">Tags</label>
                        <!-- <select id="tags" formControlName="tags" class="form-control">
                            <option value="" disabled selected>Select Tgas</option>
                            <ng-container *ngFor="let item of tagsArray">
                                <option [value]=item.tagName>{{item.tagName}}</option>
                            </ng-container>
                        </select> -->
                        <ng-multiselect-dropdown style="width: 400px;" formControlName="tags" class="form-select"
                            [placeholder]="'Select Tgas'" [settings]="tagsSettings" [data]="tagsArray">
                        </ng-multiselect-dropdown>
                        <div *ngIf="musicForm.get('tags').hasError('required') && musicForm.get('tags').touched">
                            <small class="text-danger">Tags is required.</small>
                        </div>
                    </div>
                </div>
                <!-- Content Details Section -->
                <div class="section-header">Content Details</div>
                <hr class="section-divider">
                <div style="display: flex;width: 90%;justify-content: space-between;">
                    <div class="form-group">
                        <label for="name">Name</label>
                        <input style="width:300px;margin-right: 20px;" type="text" id="name" class="form-control"
                            placeholder="Enter Name" formControlName="name">
                        <div *ngIf="musicForm.get('name').hasError('required') && musicForm.get('name').touched">
                            <small class="text-danger">Name is required.</small>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="artist">Artist</label>
                        <select formControlName="artist" style="width:300px;margin-right: 20px;" id="publisher"
                            class="form-control">
                            <option value="" disabled selected>Select Artist</option>
                            <ng-container *ngFor="let item of artistArray">
                                <option [value]=item.artistName>{{item.name}}</option>
                            </ng-container>
                        </select>
                        <div *ngIf="musicForm.get('artist').hasError('required') && musicForm.get('artist').touched">
                            <small class="text-danger">Artist is required.</small>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="artist">Featured Artist</label>
                        <select formControlName="featuredArtist" style="width:300px;margin-right: 20px;" id="publisher"
                            class="form-control">
                            <option value="" disabled selected>Select Featured Artist</option>
                            <ng-container *ngFor="let item of artistArray">
                                <option [value]=item.artistName>{{item.name}}</option>
                            </ng-container>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="album">Album</label>
                        <input formControlName="album" style="width:300px;margin-right: 20px;" type="text" id="album"
                            class="form-control" placeholder="Enter Album Name">
                        <div *ngIf="musicForm.get('album').hasError('required') && musicForm.get('album').touched">
                            <small class="text-danger">Album is required.</small>
                        </div>
                    </div>
                </div>
                <div style="display: flex;width: 59%;justify-content: space-between;">
                    <div class="form-group">
                        <label for="shortDescription">Short Description</label>
                        <textarea formControlName="shortDescription" style="margin-right: 20px;min-height: 100px;"
                            id="shortDescription" class="form-control" placeholder="Enter Short Description"></textarea>
                        <div
                            *ngIf="musicForm.get('shortDescription').hasError('required') && musicForm.get('shortDescription').touched">
                            <small class="text-danger">Short Description is required.</small>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="description">Description</label>
                        <textarea formControlName="description" style="margin-right: 20px;min-height: 100px;"
                            id="description" class="form-control" placeholder="Enter Description"></textarea>
                    </div>
                    <div class="form-group">
                        <label for="language" style="margin-left: 40px;">Add/Edit Language</label>
                        <select formControlName="language"
                            style="width:300px;margin-right: 20px;margin:40px;margin-top: 0px;" id="language"
                            class="form-control">
                            <option value="" disabled selected>Select Language</option>
                            <ng-container *ngFor="let item of languageArray">
                                <option [value]=item.languageName>{{item.languageName}}</option>
                            </ng-container>
                        </select>
                        <div style="margin-top: -40px;margin-left: 40px;"
                            *ngIf="musicForm.get('language').hasError('required') && musicForm.get('language').touched">
                            <small class="text-danger">Language is required.</small>
                        </div>
                    </div>
                </div>
                <!-- Category Section -->
                <div class="section-header">Genres</div>
                <hr class="section-divider">
                <div style="display: flex;width: 59%;justify-content: space-between;">
                    <div class="form-group">
                        <label for="category">Genre</label>
                        <select formControlName="genre" id="publisher" class="form-control">
                            <option value="" disabled selected>Select Genres</option>
                            <ng-container *ngFor="let item of genreArray">
                                <option [value]=item.categoryName>{{item.categoryName}}</option>
                            </ng-container>
                        </select>
                        <div *ngIf="musicForm.get('genre').hasError('required') && musicForm.get('genre').touched">
                            <small class="text-danger">Genre is required.</small>
                        </div>
                    </div>
                    <!-- <div class="form-group">
                    <label for="tags">Tags</label>
                    <select id="tags" class="form-control">
                        <option value="" disabled selected>Select Tags</option>
                        <option value="tag1">Tag 1</option>
                        <option value="tag2">Tag 2</option>
                      
                    </select>
                </div> -->
                </div>
                <!-- CRBT Entry Section -->
                <!-- <div class="section-header">CRBT Entry</div>
                <hr class="section-divider">
                <div class="form-group">
                    <label for="crbtEntry">Search CRBT Entry</label>
                    <input type="text" id="crbtEntry" class="form-control" placeholder="Search existing CRBT Entry">
                </div>
                <div class="note">
                    <p>Note:</p>
                    <ul>
                        <li>This value is just to know if CRBT song exists with some other publisher, this doesn't have
                            any effect on current entry.</li>
                        <li>Make sure you select song if already exists.</li>
                        <li>You still have to upload the CRBT file.</li>
                        <li>Applicable only if you want to upload CRBT file.</li>
                    </ul>
                </div> -->

                <!-- Music File Section -->
                <div class="section-header">Music File</div>
                <hr class="section-divider">

                <div style="display: flex; justify-content: space-between;">
                    <!-- Music File Upload -->
                    <div class="form-group file-upload">
                        <label for="musicFile">Music File</label>
                        <input type="file" formControlName="musicFile" id="musicFile" accept=".mp3"
                            (change)="onMusicFileSelected($event)">
                        <span style="font-weight: 600;">Upload valid MP3 File.</span>
                        <div
                            *ngIf="musicForm.get('musicFile').hasError('required') && musicForm.get('musicFile').touched">
                            <small class="text-danger">Music File is required.</small>
                        </div>
                        <div class="drag-drop-area" style="padding:25px">
                            <div *ngIf="musicFileUrl">
                                <audio style="height: 70px;margin-left: -23px;padding: 10px;" controls
                                    [src]="!selectedMuiscFile ? 'https://' + musicFileUrl : musicFileUrl"
                                    *ngIf="musicFileUrl">
                                </audio>
                            </div>
                        </div>
                    </div>

                    <!-- CRBT File Upload -->
                    <div class="form-group file-upload">
                        <label for="crbtFile">CRBT File</label>
                        <input type="file" formControlName="crbtFile" id="crbtFile" accept=".wav"
                            (change)="onAudioFileSelected($event, 'crbt')">
                        <span style="font-weight: 600;">Upload valid WAV File.</span>
                        <div
                            *ngIf="musicForm.get('crbtFile').hasError('required') && musicForm.get('crbtFile').touched">
                            <small class="text-danger">CRBT File is required.</small>
                        </div>
                        <div class="drag-drop-area" style="padding:25px">
                            <div *ngIf="crbtFileUrl">
                                <audio style="height: 70px;margin-left: -23px;padding: 10px;" controls
                                    [src]="!selectedCrbtFile ? 'https://' + crbtFileUrl : crbtFileUrl"
                                    *ngIf="crbtFileUrl">
                                </audio>
                            </div>
                        </div>
                    </div>

                    <!-- IVR File Upload -->
                    <div class="form-group file-upload" style="margin-right: 20vw;">
                        <label for="ivrFile">IVR File</label>
                        <input type="file" formControlName="ivrFile" id="ivrFile" accept=".wav"
                            (change)="onAudioFileSelected($event, 'ivr')">
                        <span style="font-weight: 600;">Upload valid WAV File.</span>
                        <div *ngIf="musicForm.get('ivrFile').hasError('required') && musicForm.get('ivrFile').touched">
                            <small class="text-danger">IVR File is required.</small>
                        </div>
                        <div class="drag-drop-area" style="padding:25px">
                            <div *ngIf="ivrFileUrl">
                                <audio style="height: 70px;margin-left: -23px;padding: 10px;" controls
                                    [src]="!selectedIvrFile ? 'https://' + ivrFileUrl : ivrFileUrl" *ngIf="ivrFileUrl">
                                </audio>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Content Section -->
                <div class="section-header">Content</div>
                <hr class="section-divider">
                <div class="form-group file-upload">
                    <label for="previewImage">Preview Image</label>
                    <input (change)="previewImageFile($event)" accept=".jpg, .png" type="file"
                        formControlName="previewImage">
                    <span style="font-weight: 600;">Upload a valid PNG or JPG file.</span>
                    <div
                        *ngIf="musicForm.get('previewImage').hasError('required') && musicForm.get('previewImage').touched">
                        <small class="text-danger">Image File is required.</small>
                    </div>
                    <div class="drag-drop-area">
                        <img *ngIf="previewImageUrl"
                            [src]="!this.preViewImage ? 'https://' + previewImageUrl : previewImageUrl"
                            alt="Image Preview" style="object-fit: cover;width: 100%;height: 100%;opacity: .7;">
                    </div>
                </div>

                <!-- Price Details Section -->
                <!-- <div class="section-header">Price Details</div>
                <hr class="section-divider">
                <div class="form-group">
                    <label for="eligiblePrice">Eligible Price Details</label>
                    <select id="eligiblePrice" class="form-control">
                        <option value="" disabled selected>Select Price Plan</option>
                        <option value="plan1">Plan 1</option>
                        <option value="plan2">Plan 2</option>
                 
                    </select>
                </div> -->

                <!-- Countries Section -->
                <div class="section-header">Countries</div>
                <hr class="section-divider">
                <div style="display: flex;">
                    <span style="margin-right: 20px;">
                        <input type="radio" name="countryType" style="margin-right: 10px;"
                            (change)="selectCountry('Eligible')" [checked]="selectedCountries === 'Eligible'" />
                        <span>Eligible Country</span>
                    </span>
                    <span>
                        <input type="radio" name="countryType" style="margin-right: 10px;"
                            (change)="selectCountry('Restricted')" [checked]="selectedCountries === 'Restricted'" />
                        <span>Restricted Country</span>
                    </span>
                </div>

                <div style="display: flex; width: 60%; justify-content: space-between; margin-top: 20px;">
                    <div class="form-group" *ngIf="selectedCountries === 'Eligible'">
                        <label for="eligibleCountires">Countries</label>
                        <ng-multiselect-dropdown formControlName="eligibleCountires" style="width: 300px;"
                            class="form-select" [placeholder]="'Select Country'" [settings]="countrySettings"
                            [data]="countryArray"></ng-multiselect-dropdown>
                    </div>
                    <div class="form-group" *ngIf="selectedCountries === 'Restricted'">
                        <label for="restrictedCountries">Countries</label>
                        <ng-multiselect-dropdown formControlName="restrictedCountries" style="width: 300px;"
                            class="form-select" [placeholder]="'Select Country'" [settings]="countrySettings"
                            [data]="countryArray"></ng-multiselect-dropdown>
                    </div>
                </div>


                <!-- DRM Section -->
                <!-- <div class="section-header"> <input type="checkbox" style="position: relative;top: .1em;left: .3em;"
                        id="enforceDrm"><span style="margin-left: 10px;font-size: 15px !important;;font-weight: 400;">Enforce DRM
                        (Digital Rights Management)</span>
                </div> -->
                <!-- <div class="form-group drm-checkbox">
                    <input type="checkbox" id="enforceDrm">
                    <label for="enforceDrm">Enable DRM Protection</label>
                </div> -->

                <!-- Action Buttons -->
                <div class="modal-footer" style="margin-left: -20px;margin-top: 20px;">
                    <button (click)="onAddMusic();" type="button" class="btn btn-primary"
                        style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;">
                        {{toBeEditedTagId ? 'Edit' : 'Add'}}
                    </button>
                    <button type="button" class="btn btn-secondary"
                        style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                        (click)="this.openMusicAddForm = false; this.music = true;">
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    </ng-container>

    <ng-container *ngIf="music">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{' / '}}
            <ng-container *ngIf="assignSongsToParticularObj; else defaultPath">
                <a href="javascript:void(0);"
                    style="color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1)); text-decoration: none;"
                    (click)="moveToContainers(this.containersNmae)">Containers</a>
                {{' / '}}
                {{ this.filteredText == 'viewSongs' 
                    ? 'View Songs' 
                    : 'Assign ' + (this.containersNmae == 'Callertunes' ? 'Callertunes' : 'Songs') }}
            </ng-container>
            <ng-template #defaultPath>
                Content Programming {{' / '}} View Content {{' / '}} Music List
            </ng-template>
        </span>
        <div class="table-container">
            <div class="table-header"
                style="display: flex; align-items: center; justify-content: space-between; padding: 5px; background-color: #f5f5f5;">
                <span style="display: block;">
                    <span style="display:flex;margin-bottom: 20px;margin-top: 10px;">
                        <span style="margin-top: 5px;margin-left:10px">
                            {{this.containersNmae == 'Callertunes' ? "Callertune" : "Music"}} List
                        </span>
                    </span>
                    <div class="form-group" *ngIf="showFilteredOptions" style="display: flex; margin-left: 20px;">
                        <form style="display: flex;" [formGroup]="filterForm" (ngSubmit)="onFilterMuisc()">
                            <span>
                                <label for="artist">Publisher Name</label>
                                <input
                                    style="width: 200px;margin-right: 15px;font-size: 15px !important;;padding: 8px;height: 6.3vh;"
                                    placeholder="Enter Publisher Name" formControlName="publisher" type="text"
                                    id="publisher" class="form-control">
                            </span>
                            <span>
                                <label for="artist">Artist</label>
                                <ng-select formControlName="artist" [items]="artistArray" bindLabel="artistName"
                                    bindValue="artistName" placeholder="Select Artist" class="form-select"
                                    [searchable]="true"
                                    style="width: 200px; margin-right: 15px;border:none; font-size: 15px !important;;">
                                </ng-select>
                            </span>
                            <span style="margin-left:10px;">
                                <label for="date">Start Date</label>
                                <input
                                    style="width: 200px !important;font-size: 15px !important;;padding: 8px;height: 6.3vh;"
                                    formControlName="startDate" type="date" id="startDate" class="form-control"
                                    min="1900-01-01" max="9999-12-31">
                            </span>

                            <span style="margin-left:10px;">
                                <label for="date">End Date</label>
                                <input
                                    style="width: 200px !important;font-size: 15px !important;;padding: 8px;height: 6.3vh;"
                                    formControlName="endDate" type="date" id="endDate" class="form-control"
                                    min="1900-01-01" max="9999-12-31">
                            </span>
                            <span>
                                <button type="submit" class="custom-btn-filter"
                                    style="margin-top: 30px; width: 100px; margin-left: 50px;">
                                    Filter
                                </button>
                            </span>
                            <span>
                                <button type="button" (click)="onResetFilters()" class="custom-btn-reset"
                                    style="margin-top: 30px; width: 125px; margin-left: 10px;">
                                    Reset Filters
                                </button>
                            </span>

                        </form>
                    </div>
                </span>
                <span (click)="this.showFilteredOptions = !this.showFilteredOptions"
                    style="display: inline-flex; align-items: center; cursor: pointer;">
                    <i class="fas fa-filter" style="margin-right: 5px;position: relative;"
                        [ngStyle]="{'top': showFilteredOptions ? '-3.5em' : '0em'}"></i>
                </span>
            </div>
            <div class="table-controls">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Music')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Music')"
                            (keypress)="preventSpace($event)"
                            [attr.placeholder]="'Search for ' + (this.containersNmae == 'Callertunes' ? 'Callertune' : 'Song') + '...'"
                            class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>
            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No</th>
                        <th *ngIf="this.filteredText!='viewSongs'" style="text-align: center;"><input [checked]="selectAll" type="checkbox"
                                (change)="onCheckboxChange($event)">

                        </th>
                        <th style="text-align: center;">Image</th>

                        <th style="text-align: center;" (click)="sortData('id', 'Music')">{{this.containersNmae ==
                            'Callertunes' ? "Callertune" : "Music"}} Id
                            <span style="float: right;" *ngIf="sortColumn === 'id'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('songName', 'Music')">Name
                            <span style="float: right;" *ngIf="sortColumn === 'songName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('artists', 'Music')">Artist
                            <span style="float: right;" *ngIf="sortColumn === 'artists'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('genres', 'Music')">Genres
                            <span style="float: right;" *ngIf="sortColumn === 'genres'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('publisher', 'Music')">Publisher
                            <span style="float: right;" *ngIf="sortColumn === 'publisher'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('dateAdded', 'Music')">Date Added
                            <span style="float: right;" *ngIf="sortColumn === 'dateAdded'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('status', 'Music')">Status
                            <span style="float: right;" *ngIf="sortColumn === 'status'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <!-- <th style="text-align: center;" (click)="sortData('deployedOn', 'Music')">Deployed On
                            <span style="float: right;" *ngIf="sortColumn === 'deployedOn'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('status', 'Music')">Status
                            <span style="float: right;" *ngIf="sortColumn === 'status'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th> -->
                        <th style="text-align: center;">Options</th>
                        <th *ngIf="this.filteredText=='viewSongs'" style="text-align: center;">Action</th>
                        <!-- <th style="text-align: center;">Publisher-Publishers</th> -->
                    </tr>
                </thead>
                <tbody>
                    <!-- Check if the filtered tags list is empty -->
                    <tr *ngIf="musicArray?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of musicArray; let i = index">
                        <td style="font-size: 15px !important;; text-align: center;">{{ (currentPage - 1) * pageSize + i
                            + 1 }}</td>
                        <td *ngIf="this.filteredText!='viewSongs'" [class.disabled-row]="!publisher.status || (!publisher.status && !viewContent)"
                            style="font-size: 15px !important;; text-align: center;">
                            <input type="checkbox" [(ngModel)]="publisher.checked"
                                (click)="onIndividualCheck(publisher, 'music')" />
                        </td>
                        <td style="font-size: 15px !important;;text-align: center;"><img
                                style="height: 40px;width: 40px;border-radius: 50%;"
                                [src]="publisher.thumbnail ? publisher.thumbnail : publisher.songThumbnail " alt="">
                        </td>
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ publisher.title }}</td> -->
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.id }}</td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.songName}}</td>
                        <td style="font-size: 15px !important;; text-align: center;">
                            {{ publisher?.artists && publisher.artists != null ? publisher?.artists : '' }}
                        </td>

                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.genres ?
                            publisher.genres : '' }}
                        </td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.publisher }}</td>
                        <td style="font-size: 15px !important;;text-align: center;white-space: nowrap;">{{ publisher.dateAdded ?
                            publisher.dateAdded :
                            publisher.releaseDate}}</td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.status ? 'Active' :
                            'Inactive'}}
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;">
                            <audio style="height: 70px; padding: 10px;" controls [src]="publisher.streamUrl"></audio>
                        </td>
                        <td *ngIf="this.filteredText=='viewSongs'" class="center">
                            <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'song','songPlaylIst');"
                                    class="remove-btn">
                             Remove
                            </button>
                        </td>
                        <!-- <td style="font-size: 15px !important;;text-align: center; display:flex; justify-content: space-between;    border: none;
                    align-items: center;
                    padding: 10px;border-top: 1px solid black;">
                        <span>{{ publisher.status == 'Approval Pending' ? 'Pending' : publisher.status}}</span>
                        <ng-container *ngIf="selectedTab === 'Pending' || selectedTab === 'Approved'">
                            <span *ngIf="publisher.status == 'Approval Pending'">
                                <button
                                    (click)="openAddForm(openStatusChangeModal); chnageMuiscStatus('Approve', publisher)"
                                    class="n_btn"
                                    style="background-color: green !important;color: white !important;border-radius: 4px;">Approve</button>
                                <button
                                    (click)="openAddForm(openStatusChangeModal); chnageMuiscStatus('Reject', publisher)"
                                    class="n_btn"
                                    style="background-color: red !important;color: white !important;border-radius: 4px;">Reject</button>
                            </span>
                            <span *ngIf="publisher.status == 'Approved'">
                                <button
                                    (click)="openAddForm(openStatusChangeModal); chnageMuiscStatus('Deploy', publisher)"
                                    class="n_btn"
                                    style="background-color: green !important;color: white !important;border-radius: 4px;">Deploy</button>
                                <button
                                    (click)="openAddForm(openStatusChangeModal); chnageMuiscStatus('Reject', publisher)"
                                    class="n_btn"
                                    style="background-color: red !important;color: white !important;border-radius: 4px;">Reject</button>
                            </span>
                        </ng-container>
                    </td> -->
                        <!-- <td style="font-size: 15px !important;;text-align: center;">
                        <button *ngIf="showUserDropdown()" (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Muisc')"
                            style="margin-right: 8px;padding: 5px;border: none;background: none;margin-left: 5px;text-align: center;">
                            <i class="fa fa-close"></i> Delete</button>
                        <button *ngIf="CreateMusicPermissions()"
                            (click)="this.music=false; this.openMusicAddForm = true; EditTag(publisher, 'Muisc')"
                            style="margin-right: 8px;padding: 5px;border: none;background: none;margin-left: 5px;text-align: center;">
                            <i class="fas fa-pen"></i> Edit</button>
                        <button (click)="fetchMusicDetails(publisher)"
                            style="margin-right: 8px; padding: 5px; border: none; background: none; margin-left: 5px; text-align: center;">
                            <i class="fas fa-download" style="color:lightgreen;"></i> Fetch
                        </button>
                    </td> -->
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ 'View' }} <i class="fas fa-share"></i></td> -->
                    </tr>
                </tbody>
            </table>

            <!-- <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">Showing 1 to 6 of 6 entries
                    <div style="margin-top: 10px;margin-bottom: 10px;">
                        <button class="n_btn">Select All</button>
                        <button class="n_btn">Unselect</button>
                        <button class="n_btn">Select Tag</button>
                        <button class="n_btn">Remove Tag</button>
                        <button class="n_btn">Deploy</button>
                        <button class="n_btn">Undeploy</button>
                    </div>
                </span>
                <span><button style="margin-right: 10px;font-size: 15px !important;;" (click)="previousPage(paginatedPublishers)"
                        [disabled]="currentPage === 1">
                        <i class="fas fa-chevron-left"></i> Previous
                    </button>
                    <span style="font-size: 15px !important;;">Page {{ currentPage }} of {{ totalPages }}</span>
                    <button style="margin-left: 10px; margin-right: 10px;font-size: 15px !important;;" (click)="nextPage(paginatedPublishers)"
                        [disabled]="currentPage === totalPages">
                        Next <i class="fas fa-chevron-right"></i>
                    </button>
                </span>
            </div> -->

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                    <div style="margin-top: 10px; margin-bottom: 10px;" *ngIf="this.filteredText!='viewSongs'">
                        <button class="n_btn" (click)="selectAllMuisc();">Select All</button>
                        <button class="n_btn" (click)="UnselectRecords();">Unselect All</button>
                        <button *ngIf="!viewContent" class="n_btn" (click)="SelectMUsic()">Add {{this.containersNmae ==
                            'Callertunes' ? "Callertune" : "Song"}}</button>
                        <!-- <button *ngIf="!muiscId" class="n_btn" (click)="SelectTag(openTagModel, 'Add')">Hidden Songs</button> -->
                        <button *ngIf="viewContent" class="n_btn" (click)="RemoveTag(openTagModel, 'Remove')">Hide
                            Songs</button>
                    </div>
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(musicArray, 'Music')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,musicArray, 'Music')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(musicArray, 'Music')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>
        </div>
    </ng-container>

    <ng-template #addDeleteModal let-modal>
        <div class="modal-dialog">
            <div class="modal-content change-password-container">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm Delete</h5>
                    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body" style="padding: 20px;width:100vw; word-break:break-all;">
                    <p style="margin-top: 5px;">Are you sure you want to delete the {{toBeDeletedText}} ?</p>
                </div>
                <div class="modal-footer" style="margin-top: 0px;">
                    <button class="btn btn-primary custom-btn-add" style="margin-right: 10px;"
                        (click)="deleteFunc()">Delete</button>
                    <button class="btn btn-secondary custom-btn-cancel"
                        (click)="modal.dismiss('Cross click')">Cancel</button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #openStatusChangeModal let-modal>
        <div class="modal-dialog">
            <div class="modal-content change-password-container">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm {{statusChangeText}}</h5>
                    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body" style="padding: 20px;height: 15vh;width:100vw; word-break:break-all;">
                    <p style="margin-top: 5px;">Are you sure you want to {{statusChangeText}} the selected Record ?</p>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary custom-btn-add" style="margin-right: 10px;"
                        (click)="onMuiscStatusChange()">
                        {{ statusChangeText || 'Action' }}
                    </button>
                    <button class="btn btn-secondary custom-btn-cancel"
                        (click)="modal.dismiss('Cross click')">Cancel</button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #openLogOutModel let-modal>
        <div class="modal-dialog">
            <div class="modal-content change-password-container">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm {{statusChangeText}}</h5>
                    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body" style="padding: 20px;height: 15vh;width:100vw; word-break:break-all;">
                    <p style="margin-top: 15px; margin-left:5px">Are you sure you want to logout ?</p>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success custom-btn-logout" (click)="logout()">
                        Logout
                    </button>
                    <button class="btn btn-secondary custom-btn-cancel"
                        (click)="modal.dismiss('Cross click')">Cancel</button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #openTagModel let-modal>
        <div class="modal-dialog">
            <div class="modal-content change-password-container">
                <div class="modal-header">
                    <h5 class="modal-title">{{selectedTax}} Tag</h5>
                    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body" style="padding: 20px;height: 15vh;width:100vw; word-break:break-all;">
                    <div class="form-group">
                        <form [formGroup]="tagsListingForm"
                            (ngSubmit)="onUpdateTagsStatus(selectedTax === 'Remove' ? true : false)">
                            <label for="tags">Tags</label>
                            <ng-multiselect-dropdown style="width: 400px;" formControlName="tags" class="form-select"
                                [placeholder]="'Select Tags'" [settings]="tagsSettings" [data]="tagsArray">
                            </ng-multiselect-dropdown>
                            <div
                                *ngIf="tagsListingForm.get('tags').hasError('required') && tagsListingForm.get('tags').touched">
                                <small class="text-danger">Tags is required.</small>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="modal-footer" style="margin-top: 30px;">
                    <button class="btn btn-secondary" (click)="modal.dismiss('Cross click')">Cancel</button>
                    <button [ngClass]="selectedTax === 'Remove' ? 'btn btn-danger' : 'btn btn-success'"
                        (click)="onUpdateTagsStatus(selectedTax === 'Remove' ? true : false)">
                        {{selectedTax}}
                    </button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-container *ngIf="role && roleArray.genre">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{'/'}}
            <a href="javascript:void(0);"
                style="color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1)); text-decoration: none;"
                (click)="moveToContainers(this.containersNmae);this.searchTerm = '';">Containers</a>
            {{'/'}} Carousel Content
        </span>

        <div class="table-container">
            <div class="table-header">
                <button (click)="moveToAssignSongs(this.CarosulesConetnt, 'addContent');this.showFilteredOptions = false; this.viewContent = false;"
                    *ngIf="genres?.length < 15" class="btn-create add_content"
                    style="font-size: 15px !important;;font-weight: 600; width: fit-content !important;">
                    <i class="fas fa-plus"></i> Add Content
                </button>
            </div>
            <div class="table-controls" style="padding: 20px;padding-bottom: 0;">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Role')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Role')"
                            (keypress)="preventSpace($event)" placeholder="Search for genre..." class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>
            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No</th>
                        <th style="text-align: center;">Image</th>
                        <th style="text-align: center;" (click)="sortData('genresName', 'Role')">Genre Name
                            <span style="float: right;" *ngIf="sortColumn === 'genresName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="drop($event)">
                    <tr *ngIf="roleArray.genres?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of roleArray.genres; let i = index" cdkDrag>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            (currentPage - 1) *
                            pageSize + i + 1 }}</td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">
                            <img style="height: 40px;width: 40px;border-radius: 50%;" [src]="publisher.thumbnailUrl"
                                alt="" />
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            publisher.genresName
                            }}</td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">
                            <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Genre', '')"
                                style="margin-right: 8px; padding: 8px; border: none; background: none; margin-left: 5px; text-align: center; background-color: darkorange; border-radius: 5px;">
                                Remove
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(roleArray.genres,'Role')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,roleArray.genres, 'Role')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(roleArray.genres,'Role')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>

        </div>
        <ng-template #addRoleModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Role</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form -->
                <form [formGroup]="roleForm" (ngSubmit)="onAddRole();" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="role" class="form-label">Role <span style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown class="form-select" [placeholder]="'Select Role'"
                            [settings]="dropdownSettings" [data]="roleArray" formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid" class="text-danger">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"
                    style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddRole()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

    <ng-container *ngIf="role && roleArray.globalMIX">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{'/'}}
            <a href="javascript:void(0);"
                style="color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1)); text-decoration: none;"
                (click)="moveToContainers(this.containersNmae);this.searchTerm = '';">Containers</a>
            {{'/'}} Carousel Content
        </span>

        <div class="table-container">
            <div class="table-header">
                <button (click)="moveToViewALLContent(this.CarosulesConetnt); this.addGloboloContent = 'globalPlayListContent'"
                    *ngIf="globalPlaylistsArray?.length < 15" class="btn-create add_content"
                    style="font-size: 15px !important;;font-weight: 600; width: fit-content !important;">
                    <i class="fas fa-plus"></i> Add Content
                </button>
            </div>
            <div class="table-controls" style="padding: 20px;padding-bottom: 0;">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Role')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Role')"
                            (keypress)="preventSpace($event)" placeholder="Search for global Playlists..." class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>
            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No</th>
                        <th style="text-align: center;">Image</th>
                        <th style="text-align: center;" (click)="sortData('playlistName', 'Role')">Playlist Name
                            <span style="float: right;" *ngIf="sortColumn === 'playlistName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="dropGlobalPlayMIX($event)">
                    <tr *ngIf="roleArray.globalPlaylists?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of roleArray.globalPlaylists; let i = index" cdkDrag>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            (currentPage - 1) *
                            pageSize + i + 1 }}</td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">
                            <img style="height: 40px;width: 40px;border-radius: 50%;" [src]="publisher.thumbnail"
                                alt="" />
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            publisher.playlistName
                            }}</td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">
                            <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'playlist', '')"
                                style="margin-right: 8px; padding: 8px; border: none; background: none; margin-left: 5px; text-align: center; background-color: darkorange; border-radius: 5px;">
                                Remove
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(roleArray.globalPlaylists,'Role')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,roleArray.globalPlaylists, 'Role')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(roleArray.globalPlaylists,'Role')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>

        </div>
        <ng-template #addRoleModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Role</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form -->
                <form [formGroup]="roleForm" (ngSubmit)="onAddRole();" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="role" class="form-label">Role <span style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown class="form-select" [placeholder]="'Select Role'"
                            [settings]="dropdownSettings" [data]="roleArray" formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid" class="text-danger">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"
                    style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddRole()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

    <ng-container *ngIf="role && roleArray.artist">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{'/'}}
            <a href="javascript:void(0);"
                style="color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1)); text-decoration: none;"
                (click)="moveToContainers(this.containersNmae);this.searchTerm = ''">Containers</a>
            {{'/'}} Carousel Content
        </span>

        <div class="table-container">
            <div class="table-header">
                <button (click)="moveToAssignSongs(this.CarosulesConetnt, 'addContent');this.showFilteredOptions = false;this.viewContent = false;"
                    *ngIf="artistDetails?.length < 15" class="btn-create add_content"
                    style="font-size: 15px !important;;font-weight: 600;width: fit-content !important;">
                    <i class="fas fa-plus"></i> Add Content
                </button>
            </div>
            <!-- 
            <span>Artist</span> -->

            <div class="table-controls" style="padding: 20px;padding-bottom: 0;">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Role')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Role')"
                            (keypress)="preventSpace($event)" placeholder="Search for artist..." class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No

                        </th>
                        <th style="text-align: center;">Image

                        </th>
                        <th style="text-align: center;" (click)="sortData('artistName', 'Role')">Artist Name
                            <span style="float: right;" *ngIf="sortColumn === 'artistName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="dropArtistDetails($event)">
                    <tr *ngIf="roleArray.artistDetails?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of roleArray.artistDetails; let i = index" cdkDrag>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            (currentPage - 1) *
                            pageSize + i + 1 }}</td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">
                            <img style="height: 40px;width: 40px;border-radius: 50%;" [src]="publisher.thumbnailUrl"
                                alt="" />
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            publisher.artistName
                            }}</td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">
                            <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Artist','')"
                                style="margin-right: 8px; padding: 8px; border: none; background: none; margin-left: 5px; text-align: center; background-color: darkorange; border-radius: 5px;">
                                Remove
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(roleArray.artistDetails,'Role')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,roleArray.artistDetails, 'Role')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(roleArray.artistDetails,'Role')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>

        </div>
        <ng-template #addRoleModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Role</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form -->
                <form [formGroup]="roleForm" (ngSubmit)="onAddRole();" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="role" class="form-label">Role <span style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown class="form-select" [placeholder]="'Select Role'"
                            [settings]="dropdownSettings" [data]="roleArray" formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid" class="text-danger">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"
                    style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddRole()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

    <ng-container *ngIf="role && roleArray.song">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{'/'}}
            <a href="javascript:void(0);"
                style="color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1)); text-decoration: none;"
                (click)="moveToContainers(this.containersNmae);this.searchTerm = ''">Containers</a>
            {{'/'}} Carousel Content
        </span>

        <div class="table-container">
            <div class="table-header">
                <button (click)="moveToAssignSongs(this.CarosulesConetnt, 'addContent');this.showFilteredOptions = false;this.viewContent = false;"
                    *ngIf="songDetailsArray?.length < 15" class="btn-create add_content"
                    style="font-size: 15px !important;;font-weight: 600;width: fit-content !important;">
                    <i class="fas fa-plus"></i> Add Content
                </button>
            </div>
            <!-- <div class="table-header">
                <button class="btn-create add_content" style="font-size: 15px !important;;font-weight: 600;">
                    <i class="fas fa-plus"></i> Add Content
                </button>
            </div> -->

            <div class="table-controls" style="padding: 20px;padding-bottom: 0;">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Role')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container" style="margin-right: 0px !important;">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Role')"
                            (keypress)="preventSpace($event)" placeholder="Search for song..." class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">
                            S.No
                        </th>
                        <th style="text-align: center;">
                            Image
                        </th>
                        <th style="text-align: center;" (click)="sortData('songName', 'Role')">
                            Name
                            <span style="float: right;" *ngIf="sortColumn === 'songName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('artists', 'Role')">
                            Artist
                            <span style="float: right;" *ngIf="sortColumn === 'artists'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('album', 'Role')">
                            Album
                            <span style="float: right;" *ngIf="sortColumn === 'album'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('dateAdded', 'Role')">
                            Date Added
                            <span style="float: right;" *ngIf="sortColumn === 'dateAdded'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="onSongDetailsDrop($event)">
                    <tr *ngIf="roleArray.songDetails?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of roleArray.songDetails; let i = index" cdkDrag>
                        <td style="font-size: 15px !important;; text-align: center;">
                            {{ (currentPage - 1) * pageSize + i + 1 }}
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;">
                            <img [src]="publisher.thumbnail" alt=""
                                style="height: 40px; width: 40px; border-radius: 50%;" />
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            publisher.songName }}
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            publisher.artists }}
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            publisher?.album ?
                            publisher?.album : publisher?.songName}}
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            publisher.dateAdded }}
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">
                            <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Song', '')"
                                style="margin-right: 8px; padding: 8px; border: none; background: none; margin-left: 5px; text-align: center; background-color: darkorange; border-radius: 5px;">
                                Remove
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(roleArray.songDetails,'Role')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,roleArray.songDetails, 'Role')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(roleArray.songDetails,'Role')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>

        </div>
        <ng-template #addRoleModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Role</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form -->
                <form [formGroup]="roleForm" (ngSubmit)="onAddRole();" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="role" class="form-label">Role <span style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown class="form-select" [placeholder]="'Select Role'"
                            [settings]="dropdownSettings" [data]="roleArray" formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid" class="text-danger">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"
                    style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddRole()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

    <ng-container *ngIf="role && roleArray.tunes">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{'/'}}
            <a href="javascript:void(0);"
                style="color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1)); text-decoration: none;"
                (click)="moveToContainers(this.containersNmae);this.searchTerm = ''">Containers</a>
            {{'/'}} Carousel Content
        </span>

        <div class="table-container">
            <div class="table-header">
                <button (click)="moveToAssignSongs(this.CarosulesConetnt, 'addContent');this.showFilteredOptions = false;this.viewContent = false;"
                    *ngIf="callertuneDetails?.length < 15" class="btn-create add_content"
                    style="font-size: 15px !important;;font-weight: 600; width: fit-content !important;">
                    <i class="fas fa-plus"></i> Add Content
                </button>
            </div>

            <div class="table-controls" style="padding: 20px;padding-bottom: 0;">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Role')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Role')"
                            (keypress)="preventSpace($event)" placeholder="Search for callertune..."
                            class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No

                        </th>
                        <th style="text-align: center;">Image

                        </th>
                        <th style="text-align: center;" (click)="sortData('songName', 'Role')">Name
                            <span style="float: right;" *ngIf="sortColumn === 'songName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('artists', 'Role')">Artist
                            <span style="float: right;" *ngIf="sortColumn === 'artists'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('album', 'Role')">Album
                            <span style="float: right;" *ngIf="sortColumn === 'album'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('releaseDate', 'Role')">Date Added
                            <span style="float: right;" *ngIf="sortColumn === 'releaseDate'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="onDrop($event)">
                    <tr *ngIf="roleArray.callertuneDetails?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of roleArray.callertuneDetails; let i = index" cdkDrag>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            (currentPage - 1) *
                            pageSize + i + 1 }}</td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">
                            <img style="height: 40px; width: 40px; border-radius: 50%;" [src]="publisher.songThumbnail"
                                alt="">
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            publisher.songName }}
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            publisher.artists }}
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            publisher.album ?
                            publisher.album : publisher.songName }}
                        </td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">{{
                            publisher.releaseDate
                            }}</td>
                        <td style="font-size: 15px !important;; text-align: center;cursor:grab !important">
                            <button
                                (click)="openAddForm(addDeleteModal); deleteModel(publisher, containersNmae === 'Callertunes' ? 'Callertune' : 'Song', '')"
                                style="margin-right: 8px; padding: 8px; border: none; background: none; margin-left: 5px; text-align: center;
                        background-color: darkorange; border-radius: 5px;">
                                Remove
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(roleArray,'Role')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,roleArray, 'Role')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(roleArray,'Role')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>

        </div>
        <ng-template #addRoleModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Role</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form -->
                <form [formGroup]="roleForm" (ngSubmit)="onAddRole();" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="role" class="form-label">Role <span style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown class="form-select" [placeholder]="'Select Role'"
                            [settings]="dropdownSettings" [data]="roleArray" formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid" class="text-danger">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"
                    style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddRole()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

    <ng-container *ngIf="conentApproval && TewxtName == 'TOP_GENRES'">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{' / '}}
            <a href="javascript:void(0);"
                style="color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1)); text-decoration: none;"
                (click)="moveToContainers(this.containersNmae)">Containers</a>
            {{' / '}}
            View All
        </span>
        <div class="table-container">
            <span
                style="position: relative;left: 1em;top: .5em;font-size: 15px !important;;font-weight: 600;">Genre</span>
            <div class="table-controls" style="padding: 20px;padding-bottom: 0;">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'ViewallArray')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('ViewallArray')"
                            (keypress)="preventSpace($event)" placeholder="Search for genre..." class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                        </th>
                        <th style="text-align: center;">Image
                        </th>
                        <th style="text-align: center;" (click)="sortData('genresName', 'ViewallArray')">Genre name
                            <span style="float: right;" *ngIf="sortColumn === 'genresName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="viewAllArray?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of viewAllArray; let i = index">
                        <td style="font-size: 15px !important;; text-align: center;">{{ (currentPage - 1) * pageSize + i
                            + 1 }}</td>
                        <td style="font-size: 15px !important;;text-align: center;"><img
                                style="height: 40px;width: 40px;border-radius: 50%;" [src]="publisher.thumbnailUrl"
                                alt="">
                        </td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.genresName }}</td>
                        <td style="font-size: 15px !important;;text-align: center;">
                            <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Genre','View')" style="margin-right: 8px;
                        padding: 8px;
                        border: none;
                        background: none;
                        margin-left: 5px;text-align: center;background-color: darkorange;
                        border-radius: 5px;">Remove</button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(viewAllArray,'ViewallArray')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,viewAllArray, 'ViewallArray')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(viewAllArray,'ViewallArray')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>

        </div>
        <ng-template #addRoleModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Role</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form -->
                <form [formGroup]="roleForm" (ngSubmit)="onAddRole();" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="role" class="form-label">Role <span style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown class="form-select" [placeholder]="'Select Role'"
                            [settings]="dropdownSettings" [data]="roleArray" formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid" class="text-danger">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"
                    style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddRole()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

    <ng-container *ngIf="conentApproval && TewxtName == 'UPCOMING_ARTIST'">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{' / '}}
            <a href="javascript:void(0);"
                style="color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1)); text-decoration: none;"
                (click)="moveToContainers(this.containersNmae)">Containers</a>
            {{' / '}}
            View All
        </span>
        <div class="table-container">
            <div class="table-header">
                <span
                    style="position: relative;left: 1em;top: .5em;font-size: 15px !important;;font-weight: 600;">Artists</span>
            </div>

            <div class="table-controls" style="padding: 20px;padding-bottom: 0;">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'ViewallArray')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('ViewallArray')"
                            (keypress)="preventSpace($event)" placeholder="Search for artist..." class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                        </th>
                        <th style="text-align: center;">Image
                        </th>
                        <th style="text-align: center;" (click)="sortData('artistName', 'ViewallArray')">Artist name
                            <span style="float: right;" *ngIf="sortColumn === 'artistName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <!-- <th style="text-align: center;">Email</th> -->
                        <th style="text-align: center;">Options</th>
                        <!-- <th style="text-align: center;">Publisher-Publishers</th> -->
                    </tr>
                </thead>
                <tbody>
                    <!-- Check if the filtered tags list is empty -->
                    <tr *ngIf="viewAllArray?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of viewAllArray; let i = index">
                        <td style="font-size: 15px !important;; text-align: center;">{{ (currentPage - 1) * pageSize + i
                            + 1 }}</td>
                        <td style="font-size: 15px !important;;text-align: center;"><img
                                style="height: 40px;width: 40px;border-radius: 50%;" [src]="publisher.thumbnailUrl"
                                alt="">
                        </td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.artistName }}</td>
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ publisher.email }}</td> -->
                        <td style="font-size: 15px !important;;text-align: center;">
                            <!-- <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'R')" style="margin-right: 8px;
                        padding: 5px;
                        border: none;
                        background: none;
                        margin-left: 5px;text-align: center;"><i class="fa fa-close"></i> Delete</button> -->
                            <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Artist','View')"
                                style="margin-right: 8px;
                        padding: 8px;
                        border: none;
                        background: none;
                        margin-left: 5px;text-align: center;background-color: darkorange;
                        border-radius: 5px;">Remove</button>
                        </td>
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ 'View' }} <i class="fas fa-share"></i></td> -->
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(viewAllArray,'ViewallArray')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,viewAllArray, 'ViewallArray')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(viewAllArray,'ViewallArray')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>

        </div>
        <ng-template #addRoleModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Role</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form -->
                <form [formGroup]="roleForm" (ngSubmit)="onAddRole();" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="role" class="form-label">Role <span style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown class="form-select" [placeholder]="'Select Role'"
                            [settings]="dropdownSettings" [data]="roleArray" formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid" class="text-danger">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"
                    style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddRole()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

    <ng-container
        *ngIf="conentApproval && (TewxtName == 'POPULAR_PARTY_HITS' || TewxtName == 'ROMANTIC_TUNES' || TewxtName == 'PARTY_TUNES' || TewxtName == 'VALENTINES_LOVE_SONGS')">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{' / '}}
            <a href="javascript:void(0);"
                style="color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1)); text-decoration: none;"
                (click)="moveToContainers(this.containersNmae)">Containers</a>
            {{' / '}}
            View All
        </span>
        <div class="table-container">

            <span
                style="position: relative;left: 1em;top: .5em;font-size: 15px !important;;font-weight: 600;">{{(TewxtName
                == 'ROMANTIC_TUNES' || TewxtName == 'PARTY_TUNES') ?'Callertunes' : 'Songs'}}</span>

            <div class="table-controls" style="padding: 20px;padding-bottom: 0;">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'ViewallArray')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container" style="margin-right: 0px !important;">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('ViewallArray')"
                            (keypress)="preventSpace($event)"
                            [attr.placeholder]="'Search for ' + ((TewxtName === 'ROMANTIC_TUNES' || TewxtName === 'PARTY_TUNES') ? 'Callertune' : 'Song') + '...'"
                            class="search-input" />

                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No

                        </th>
                        <th style="text-align: center;">Image

                        </th>
                        <th style="text-align: center;" (click)="sortData('songName', 'ViewallArray')">{{(TewxtName ==
                            'ROMANTIC_TUNES' || TewxtName == 'PARTY_TUNES') ?'Callertune name' : 'Song name'}}
                            <span style="float: right;" *ngIf="sortColumn === 'songName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('artists', 'ViewallArray')">Artist
                            <span style="float: right;" *ngIf="sortColumn === 'artists'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('genres', 'ViewallArray')">Genre
                            <span style="float: right;" *ngIf="sortColumn === 'genres'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <!-- <th style="text-align: center;">Email</th> -->
                        <th style="text-align: center;">Options</th>
                        <!-- <th style="text-align: center;">Publisher-Publishers</th> -->
                    </tr>
                </thead>
                <tbody>
                    <!-- Check if the filtered tags list is empty -->
                    <tr *ngIf="viewAllArray?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of viewAllArray; let i = index">
                        <td style="font-size: 15px !important;; text-align: center;">{{ (currentPage - 1) * pageSize + i
                            + 1 }}</td>
                        <td style="font-size: 15px !important;;text-align: center;"><img
                                style="height: 40px;width: 40px;border-radius: 50%;"
                                [src]="publisher.thumbnail ?  publisher.thumbnail : publisher.songThumbnail " alt="">
                        </td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.songName }}</td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.artists }}</td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.genres }}</td>
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ publisher.email }}</td> -->
                        <td style="font-size: 15px !important;;text-align: center;">
                            <!-- <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'R')" style="margin-right: 8px;
                        padding: 5px;
                        border: none;
                        background: none;
                        margin-left: 5px;text-align: center;"><i class="fa fa-close"></i> Delete</button> -->
                            <button
                                (click)="openAddForm(addDeleteModal); deleteModel(publisher, containersNmae === 'Callertunes' ? 'Callertune' : 'Song', 'View')"
                                style="margin-right: 8px; padding: 8px; border: none; background: none; margin-left: 5px; text-align: center;
                        background-color: darkorange; border-radius: 5px;">
                                Remove
                            </button>

                        </td>
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ 'View' }} <i class="fas fa-share"></i></td> -->
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(viewAllArray,'ViewallArray')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,viewAllArray, 'ViewallArray')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(viewAllArray,'ViewallArray')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>

        </div>
        <ng-template #addRoleModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Role</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form -->
                <form [formGroup]="roleForm" (ngSubmit)="onAddRole();" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="role" class="form-label">Role <span style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown class="form-select" [placeholder]="'Select Role'"
                            [settings]="dropdownSettings" [data]="roleArray" formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid" class="text-danger">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"
                    style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddRole()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

    <ng-container *ngIf="deployments && PropName == 'TOP_GENRES'">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{'/'}}
            <a href="javascript:void(0);"
                style="color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1)); text-decoration: none;"
                (click)="moveToContainers(this.containersNmae);this.searchTerm = ''">Containers</a>
            {{'/'}} Assign Genre
        </span>

        <div class="table-container">
            <span style="position: relative;left: 1em;top: .5em;font-size: 15px !important;;font-weight: 600;">Genre
                List</span>

            <div class="table-controls" style="padding: 20px;padding-bottom: 0;">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'assign')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('newRole')"
                            (keypress)="preventSpace($event)" placeholder="Search for genre..." class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                        </th>
                        <th style="text-align: center;">
                            <input [checked]="selectAll" type="checkbox" (change)="onCheckboxGenereArrayChange($event)">
                        </th>
                        <th style="text-align: center;">Image
                        </th>
                        <th style="text-align: center;" (click)="sortData('genresName', 'assign')">Genre name
                            <span style="float: right;" *ngIf="sortColumn === 'genresName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <!-- <th style="text-align: center;">Email</th> -->
                        <!-- <th style="text-align: center;">Options</th> -->
                        <!-- <th style="text-align: center;">Publisher-Publishers</th> -->
                    </tr>
                </thead>
                <tbody>
                    <!-- Check if the filtered tags list is empty -->
                    <tr *ngIf="ListArray?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of ListArray; let i = index">
                        <td style="font-size: 15px !important;; text-align: center;">{{ (currentPage - 1) * pageSize + i
                            + 1 }}</td>
                        <td style="font-size: 15px !important;;text-align: center;"> <input type="checkbox"
                                [(ngModel)]="publisher.checked" (click)="onIndividualCheck(publisher,'')" /></td>
                        <td style="font-size: 15px !important;;text-align: center;"><img
                                style="height: 40px;width: 40px;border-radius: 50%;" [src]="publisher.thumbnailUrl"
                                alt="">
                        </td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.genresName }}</td>
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ publisher.email }}</td> -->
                        <!-- <td style="font-size: 15px !important;;text-align: center;">
                           
                            <button style="margin-right: 8px;
                        padding: 8px;
                        border: none;
                        background: none;
                        margin-left: 5px;text-align: center;background-color: darkorange;
                        border-radius: 5px;">Remove</button>
                        </td> -->
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ 'View' }} <i class="fas fa-share"></i></td> -->
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    <div style="margin-top: 10px;margin-bottom: 10px;">
                        <button class="n_btn" (click)="selectAllRecords()">Select All</button>
                        <button class="n_btn" (click)="unselectAllRecords()">Unselect All</button>
                        <button class="n_btn" (click)="SelectGenre()">Add Genre</button>
                        <!-- <button class="n_btn">Remove Tag</button>
                        <button class="n_btn">Deploy</button>
                        <button class="n_btn">Undeploy</button> -->
                    </div>
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(countryArray,'assign')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,countryArray, 'assign')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                 'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(countryArray,'assign')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>

        </div>
        <ng-template #addRoleModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Role</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form -->
                <form [formGroup]="roleForm" (ngSubmit)="onAddRole();" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="role" class="form-label">Role <span style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown class="form-select" [placeholder]="'Select Role'"
                            [settings]="dropdownSettings" [data]="roleArray" formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid" class="text-danger">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"
                    style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddRole()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

    <ng-container *ngIf="conentApproval && TewxtName == 'GLOBAL_MIX'">
        <span class="breadcrumb-text">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{' / '}}
            <a href="javascript:void(0);" class="breadcrumb-link"
            (click)="moveToContainers(this.containersNmae)">Containers</a>
            {{' / '}}
            {{ this.addGloboloContent == 'globalPlayListContent' ? 'Assign Playlist' :'View All' }}
        </span>

        <div class="table-container">
            <div class="table-header">
            <span class="table-title">Playlists</span>
            </div>

            <div class="table-controls">
            <span>
                <label for="entries" class="entries-label">Show</label>
                <select id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'ViewallArray')" class="entries-select">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                </select>
                <span class="entries-text">entries</span>
            </span>
            <div class="search-container">
                <label for="search" class="search-label">Search:</label>
                <div class="search-wrapper">
                <input type="text" id="search" [(ngModel)]="searchTerm"
                        (input)="applySearch('ViewallArray')" (keypress)="preventSpace($event)"
                        placeholder="Search for playlist..." class="search-input" />
                <i class="fa fa-search search-icon"></i>
                </div>
            </div>
            </div>

            <table class="publisher-table">
            <thead>
                <tr>
                <th class="center">S.No</th>
                <th class="center">
                    <input [checked]="selectAll" type="checkbox" (change)="selectALLPlaylistRecords()">
                </th>
                <th class="center">Image</th>
                <th class="center" (click)="sortData('playlistName', 'ViewallArray')">
                    Playlist name
                    <span class="sort-indicator" *ngIf="sortColumn === 'playlistName'">
                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                    </span>
                </th>
                <th *ngIf="this.addGloboloContent != 'globalPlayListContent'" class="center">Options</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="viewAllArray?.length === 0">
                <td colspan="14" class="no-data">No results found.</td>
                </tr>
                <tr *ngFor="let publisher of viewAllArray; let i = index">
                <td class="center text-small">{{ (currentPage - 1) * pageSize + i + 1 }}</td>
                <td class="center text-small">
                    <input type="checkbox" [(ngModel)]="publisher.checked" (click)="onIndividualCheck(publisher,'')" />
                </td>
                <td class="center">
                    <img [src]="publisher.thumbnail" alt="" class="thumbnail">
                </td>
                <td class="center text-small">{{ publisher.playlistName }}</td>
                <td *ngIf="this.addGloboloContent != 'globalPlayListContent'" class="center">
                    <button (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'playlist','viewallPlaylist');"
                            class="remove-btn">
                    Remove
                    </button>
                </td>
                </tr>
            </tbody>
            </table>

            <div class="pagination-controls">
            <span class="entries-info">
                <div *ngIf="this.addGloboloContent == 'globalPlayListContent'" class="bulk-actions">
                <button class="n_btn" (click)="selectALLPlaylistRecords()">Select All</button>
                <button class="n_btn" (click)="unselectAllPlahyLIstRecords()">Unselect All</button>
                <button class="n_btn" (click)="this.addContent = true;SelectMUsic();">Add Playlist</button>
                </div>
                Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
            </span>

            <span>
                <button (click)="previousPage(viewAllArray,'ViewallArray')" 
                        [disabled]="currentPage === 1" class="pagination-btn">
                Previous
                </button>

                <ng-container *ngFor="let page of pages">
                <button *ngIf="page !== '...'" 
                        (click)="goToPage(page,viewAllArray, 'ViewallArray')"
                        [disabled]="page === currentPage"
                        [ngClass]="{'active-page': currentPage === page}" 
                        class="pagination-btn">
                    {{ page }}
                </button>
                <span *ngIf="page === '...'">...</span>
                </ng-container>

                <button (click)="nextPage(viewAllArray,'ViewallArray')" 
                        [disabled]="currentPage === totalPages" class="pagination-btn">
                Next
                </button>
            </span>
            </div>
        </div>
    </ng-container>


    <ng-container *ngIf="deployments && PropName == 'UPCOMING_ARTIST'">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 15px !important;;">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{'/'}}
            <a href="javascript:void(0);"
                style="color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1)); text-decoration: none;"
                (click)="moveToContainers(this.containersNmae);this.searchTerm = ''">Containers</a>
            {{'/'}} Assign Artist
        </span>

        <div class="table-container">
            <div class="table-header">
                <!-- <button class="btn-create add_content" style="font-size: 15px !important;;font-weight: 600;">
                    <i class="fas fa-plus"></i> Add Content
                </button> -->
                <span
                    style="position: relative;left: 1em;top: .5em;font-size: 15px !important;;font-weight: 600;">Artists
                    List</span>
            </div>

            <div class="table-controls" style="padding: 20px;padding-bottom: 0;">
                <span>
                    <label for="entries" style="font-size: 15px !important;;">Show</label>
                    <select style="font-size: 15px !important;;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'assign')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px !important;;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('newRole')"
                            (keypress)="preventSpace($event)" placeholder="Search for artist..." class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                        </th>
                        <th style="text-align: center;">
                            <input [checked]="selectAll" type="checkbox" (change)="onCheckboxGenereArrayChange($event)">
                        </th>
                        <th style="text-align: center;">Image
                        </th>
                        <th style="text-align: center;" (click)="sortData('artistName', 'assign')">Artist name
                            <span style="float: right;" *ngIf="sortColumn === 'artistName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <!-- <th style="text-align: center;">Email</th> -->
                        <!-- <th style="text-align: center;">Options</th> -->
                        <!-- <th style="text-align: center;">Publisher-Publishers</th> -->
                    </tr>
                </thead>
                <tbody>
                    <!-- Check if the filtered tags list is empty -->
                    <tr *ngIf="ListArray?.length === 0">
                        <td colspan="14" class="no-data">
                            <span>No results found.</span>
                        </td>
                    </tr>
                    <tr *ngFor="let publisher of ListArray; let i = index">
                        <td style="font-size: 15px !important;; text-align: center;">{{ (currentPage - 1) * pageSize + i
                            + 1 }}</td>
                        <td style="font-size: 15px !important;;text-align: center;"> <input type="checkbox"
                                [(ngModel)]="publisher.checked" (click)="onIndividualCheck(publisher,'')" /></td>
                        <td style="font-size: 15px !important;;text-align: center;"><img
                                style="height: 40px;width: 40px;border-radius: 50%;" [src]="publisher.thumbnailUrl"
                                alt="">
                        </td>
                        <td style="font-size: 15px !important;;text-align: center;">{{ publisher.artistName }}</td>
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ publisher.email }}</td> -->
                        <!-- <td style="font-size: 15px !important;;text-align: center;">
                        
                            <button style="margin-right: 8px;
                        padding: 8px;
                        border: none;
                        background: none;
                        margin-left: 5px;text-align: center;background-color: darkorange;
                        border-radius: 5px;">Remove</button>
                        </td> -->
                        <!-- <td style="font-size: 15px !important;;text-align: center;">{{ 'View' }} <i class="fas fa-share"></i></td> -->
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px !important;;">
                    <div style="margin-top: 10px;margin-bottom: 10px;">
                        <button class="n_btn" (click)="selectAllRecords()">Select All</button>
                        <button class="n_btn" (click)="unselectAllRecords()">Unselect All</button>
                        <button class="n_btn" (click)="SelectArtist()">Add Artist</button>
                        <!-- <button class="n_btn">Remove Tag</button>
                            <button class="n_btn">Deploy</button>
                            <button class="n_btn">Undeploy</button> -->
                    </div>
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px !important;;background-color: white;"
                        (click)="previousPage(countryArray,'assign')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,countryArray, 'assign')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                     'font-size': '15px',
                                    'margin': '0 5px',
                                    'background-color': currentPage === page ? '#007bff' : '',
                                    'color': currentPage === page ? '#fff' : ''
                                  }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button
                        style="margin-left: 10px; margin-right: 10px; font-size: 15px !important;; background-color: white;"
                        (click)="nextPage(countryArray,'assign')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>

        </div>
        <ng-template #addRoleModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Role</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form -->
                <form [formGroup]="roleForm" (ngSubmit)="onAddRole();" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="role" class="form-label">Role <span style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown class="form-select" [placeholder]="'Select Role'"
                            [settings]="dropdownSettings" [data]="roleArray" formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid" class="text-danger">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"
                    style="margin-right: 10px; background-color:white; color:black; font-weight: 400; font-size: 15px !important;; border: 1px solid gray;"
                    (click)="onAddRole()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}}
                </button>
                <button type="button" class="btn btn-secondary"
                    style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 15px !important;;"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

  <ng-container *ngIf="deployments && PropName == 'GLOBAL_MIX'">
        <span class="breadcrumb">
            <a onclick="window.location.reload();" class="fas fa-home"></a>
            {{'/'}} 
            <a href="javascript:void(0);" class="breadcrumb-link"
            (click)="this.filteredText = '' ;moveToContainers(this.containersNmae);this.searchTerm = '';">Containers</a>
            {{'/'}} Global Playlist
        </span>

        <div class="table-container">
            <div class="table-header golobal_playlist_header">
            <div class="header-title">Playlists List</div>
            <div>
                <button (click)="openAddPalylistForm()" class="btn-create add_content golobal_width">
                <i class="fas fa-plus"></i> Create Playlist
                </button>
            </div>
            </div>

            <div class="table-controls">
            <span>
                <label for="entries" class="label-sm">Show</label>
                <select id="entries" [(ngModel)]="recordsPerPage"
                (change)="updatePageSize($event, 'assign')" class="select-sm">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                </select>
                <span class="label-sm ml-8">entries</span>
            </span>
            <div class="search-container">
                <label for="search" class="search-label">Search:</label>
                <div class="search-wrapper">
                <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('newRole')"
                    (keypress)="preventSpace($event)" placeholder="Search for playlist..."
                    class="search-input" />
                <i class="fa fa-search search-icon"></i>
                </div>
            </div>
            </div>

            <table class="publisher-table">
            <thead>
                <tr>
                <th>S.No</th>
                <th>Image</th>
                <th (click)="sortData('playlistName', 'assign')">Playlist name
                    <span *ngIf="sortColumn === 'playlistName'" class="sort-indicator">
                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                    </span>
                </th>
                <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="ListArray?.length === 0">
                <td colspan="14" class="no-data">
                    <span>No results found.</span>
                </td>
                </tr>
                <tr *ngFor="let publisher of ListArray; let i = index">
                <td class="text-sm">{{ (currentPage - 1) * pageSize + i + 1 }}</td>
                <td class="text-sm"><img [src]="publisher.thumbnail" alt=""></td>
                <td class="text-sm">{{ publisher.playlistName }}</td>
                <td class="text-sm">
                    <button class="btn-action btn-edit" (click)="editform(publisher)">Edit</button>
                    <button class="btn-action btn-delete" (click)="openAddForm(addDeleteModal);deleteModel(publisher, 'playlist','playlist')">Delete</button>
                    <button class="btn-action btn-add" (click)="this.filteredText = '' ;moveToAssignSongs(publisher, 'addsongs');">Add Songs</button>
                    <button class="btn-action btn-view" (click)="this.publisherSongs = publisher; moveToAssignSongs(publisher, 'viewSongs');">View</button>
                </td>
                </tr>
            </tbody>
            </table>

            <div class="pagination-controls">
            <span class="pagination-info">
                Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
            </span>
            <span>
                <!-- Previous Button -->
                <button class="btn-page" (click)="previousPage(countryArray,'assign')" [disabled]="currentPage === 1">
                Previous
                </button>

                <!-- Page Numbers -->
                <ng-container *ngFor="let page of pages">
                <button *ngIf="page !== '...'" class="btn-page"
                    (click)="goToPage(page,countryArray, 'assign')" [disabled]="page === currentPage"
                    [ngClass]="{'active': currentPage === page}">
                    {{ page }}
                </button>
                <span *ngIf="page === '...'">...</span>
                </ng-container>

                <!-- Next Button -->
                <button class="btn-page" (click)="nextPage(countryArray,'assign')" [disabled]="currentPage === totalPages">
                Next
                </button>
            </span>
            </div>
        </div>
    </ng-container>

    <div class="popup" *ngIf="showPopup">
    <div class="popup-content">
        <span class="close" (click)="closePlayListPopup()">&times;</span>
        <div class="playlist-form-container">
        <h2 class="form-title">{{ formTitle }}</h2>

        <form [formGroup]="playlistForm" (ngSubmit)="onSubmitPlayLIstForm()">

            <!-- Playlist Name -->
            <div class="form-group">
            <label for="playlistName">Playlist Name <span class="required">*</span></label>
            <input maxLength = "50" type="text" id="playlistName" formControlName="playlistName"
                placeholder="Enter Valid Name" class="form-control" />
            <div *ngIf="playlistForm.get('playlistName')?.touched && playlistForm.get('playlistName')?.invalid" class="text-danger">
                Playlist name is required.
            </div>
            </div>

            <!-- Playlist Image -->
            <div class="form-group">
            <label for="playlistImage">Playlist Image <span class="required">{{formMode === 'add' ? '*' : ''}}</span></label>
            <input type="file" id="playlistImage" (change)="onPlaylIstFileSelected($event)" class="form-control" />
            <div class="image-requirements">
                <div>Image Requirements:</div>
                <ul>
                <li>Max file size: 20 KB</li>
                <li>Dimensions: 300 × 200 px</li>
                <li>Aspect ratio: 1.5:1</li>
                <li>Supported formats: JPG, PNG and WEBP only</li>
                </ul>
            </div>
            <div *ngIf="imageError" class="text-danger">{{ imageError }}</div>
            </div>

            <!-- Buttons -->
            <div class="form-actions">
                <button type="submit" class="btn btn-primary" [disabled]="playlistForm.invalid"> {{ formMode === 'add' ? 'Add Playlist' : 'Edit Playlist' }}</button>
                <button type="button" class="btn btn-secondary" (click)="closePlayListPopup()">Cancel</button>
            </div>
        </form>
        </div>
     </div>
  </div>
</div>

<div class="notification-section" *ngIf="manageNotification">
    <span class="notification-strip">
        <a onclick="window.location.reload();" class="fas fa-home"></a> {{'/'}} Content Programming {{'/'}} Notification
        Section
    </span>

    <div class="table-container">
        <div class="notification-wrapper">
            <div class="header-row">
                <p>Notifications</p>
                <div>
                    <button class="scheduled-button" routerLink="/event-notification">Scheduled Notification</button>
                    <button class="add-button" routerLink="/add-notification">+ Add Notification</button>
                </div>
            </div>
            <div class="filter-row">
                <div class="search-wrapper" id="search-wrapper" (click)="focusInput()">
                    <span for="search" class="label-search">Search:</span>
                    <i class="fa fa-search search-icon" id="search-icon"></i>
                    <input  #searchInput type="text"  [(ngModel)]="searchsTerm" (input)="onSearchChange()" placeholder="Search notifications..." />
                </div>
                <div class="filter-controls">
                    <select [(ngModel)]="selectedType" (change)="onFilterChange()">
                        <option selected value="" >All Notifications</option>
                        <option *ngFor="let t of tagsData?.notificationTypes" [value]="t?.name">{{ t?.name }}</option>
                    </select>
                    <select [(ngModel)]="selectedAudience" (change)="onFilterChange()" >
                        <option selected value="" >All Notifications</option>
                        <option *ngFor="let a of tagsData?.audienceTypes" [value]="a?.code">{{ a?.code }}</option>
                    </select>
                </div>
            </div>
        </div>



        <table class="publisher-table" id="publisher-table" >
            <thead style="border-bottom: 1px solid black;">
                <tr>
                    <th style="text-align: center;">Title
                    </th>
                    <th style="text-align: center;" (click)="sortData('name', 'Tags')">Type
                        <span style="float: right;" *ngIf="sortColumn === 'name'">
                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                        </span>
                    </th>
                    <th style="text-align: center;" (click)="sortData('description', 'Tags')">Target
                        <span style="float: right;" *ngIf="sortColumn === 'description'">
                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                        </span>
                    </th>
                    <th style="text-align: center;" (click)="sortData('description', 'Tags')">Schedule
                        <span style="float: right;" *ngIf="sortColumn === 'description'">
                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                        </span>
                    </th>
                    <th style="text-align: center;" (click)="sortData('description', 'Tags')">Created On
                        <span style="float: right;" *ngIf="sortColumn === 'description'">
                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                        </span>
                    </th>
                    <th style="text-align: center;" (click)="sortData('description', 'Tags')">Module
                        <span style="float: right;" *ngIf="sortColumn === 'description'">
                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                        </span>
                    </th>
                    <th style="text-align: center;" (click)="sortData('description', 'Tags')">Status
                        <span style="float: right;" *ngIf="sortColumn === 'description'">
                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                        </span>
                    </th>
                    <th style="text-align: center;" (click)="sortData('description', 'Tags')">Actions
                        <span style="float: right;" *ngIf="sortColumn === 'description'">
                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <!-- Check if the filtered tags list is empty -->
                <tr *ngIf="notificationData?.length === 0">
                    <td colspan="14" class="no-data">
                        <span>No results found.</span>
                    </td>
                </tr>
                <!-- Display the actual tags -->
                <tr id="tags-array" *ngFor="let item of notificationData ; let i = index">
                    <td>{{ item.title }}</td>
                    <td>{{ item.type }}</td>
                    <td>{{ item.targetAudience }}</td>
                    <td>{{ item.scheduleType }}</td>
                    <td>{{ item.createdAt.split("T")[0] }}</td>
                    <td>{{ item.moduleName }}</td>
                    <td>{{ item.status }}</td>
                    <td class="action-buttons" *ngIf=" item?.status !== 'DELETED' ">

                        <button (click)="resumeNotification(item?.id)" *ngIf=" item?.status == 'PAUSED' "
                            class="icon-btn icon-btn--play" title="Activate">
                            <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <polygon points="5,3 19,12 5,21" />
                            </svg>
                        </button>
        
                        <button (click)="pauseNotification(item?.id)" *ngIf=" item?.status == 'ACTIVE' "
                            class="icon-btn icon-btn--pause" title="Pause">
                            <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <rect x="6" y="4" width="4" height="16" rx="1" />
                                <rect x="14" y="4" width="4" height="16" rx="1" />
                            </svg>
                        </button>
        
                        <button class="icon-btn icon-btn--edit" title="Edit" (click)="edit(item?.id)">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                                stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                            </svg>
                        </button>
        
                        <button class="icon-btn icon-btn--delete"(click)="openAddForm(addDeleteModal);deleteModel(item?.id, 'notification','notification')"><i class="fa fa-trash"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="pagination-controls">
            <span style="margin-left: 10px; font-size: 15px !important;;">
                Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries}} entries
            </span>

            <span>
                <!-- Previous Button -->
                <button id="paginations-previous" (click)="previousPage(notificationData, 'notification')"
                    [disabled]="currentPage === 1">
                    Previous
                </button>

                <!-- Page Numbers -->
                <ng-container *ngFor="let page of pages">
                    <button *ngIf="page !== '...'" (click)="goToPage(page,notificationData, 'notification')"
                        [disabled]="page === currentPage" [ngStyle]="{
                              'font-size': '15px',
                             'margin': '0 5px',
                             'background-color': currentPage === page ? '#007bff' : '',
                             'color': currentPage === page ? '#fff' : ''
                           }">
                        {{ page }}
                    </button>
                    <span *ngIf="page === '...'">...</span>
                </ng-container>

                <!-- Next Button -->
                <button id="paginations-next" (click)="nextPage(notificationData, 'notification')"
                    [disabled]="currentPage === totalPages">
                    Next
                </button>
            </span>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>

